import { createContext, useContext } from 'react';
import type { OrderType } from 'state/fxOrders/fxOrdersModel';

const orderTypeContext = createContext<OrderType | null>(null);
orderTypeContext.displayName = 'OrderTypeContext';
export const { Provider: OrderTypeContextProvider, Consumer: OrderTypeContextConsumer } =
  orderTypeContext;

export const useOrderTypeContext = () => useContext(orderTypeContext);
